import { Api } from "../Config/request";
const addNewAddress = async (data) => {
  let response = await Api.PostRequest("/address", data);
  // console.log(response);
  return response;
};
const getAddress = async (data) => {
  let response = await Api.GetRequest("/address", data);
  return response;
};



const getAddressById = async (data) => {
  let response = await Api.GetRequest(`/address/${data.id}`);
  return response;
};
const deleteAddress = async (data) => {
  let response = await Api.DeleteRequest(`/address/${data.id}`, data);
  return response;
};

const searchAddress = async (query) => {
  try {
    console.log("INSIDE TRY BLOCK");
    console.log("QUERY",query);
    let response = await Api.GetRequest(`/address${query}`);
    console.log("RESPONSE", response);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

const updateAddress = async (data) => {
  let response = await Api.PutRequest(`/address/${data.id}`, data);
  return response;
};

const addressApi = { addNewAddress, getAddress, deleteAddress, updateAddress, getAddressById, searchAddress };

export default addressApi;
